import { create } from 'zustand';
import { adminCustomerManagementApi } from '@api/api-config.ts';
import { AdminCustomerListResponse } from '@api/generated/portal-be-admin';

export interface CustomerFilters {
  q?: string;
  page: number;
  size: number;
}

interface PaginationInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

interface AdminCustomerStoreState {
  loading: boolean;
  error: string | null;
  data: AdminCustomerListResponse[] | null;
  pagination: PaginationInfo | null;
  loadCustomers: (filters: CustomerFilters) => Promise<void>;
}

export const useAdminCustomerStore = create<AdminCustomerStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  pagination: null,

  loadCustomers: async (filters: CustomerFilters) => {
    try {
      set({ loading: true, error: null });
      const response = await adminCustomerManagementApi.getAdminCustomers({
        page: filters.page,
        size: filters.size,
        q: filters.q,
      });
      const result = response.data;
      set({
        loading: false,
        error: null,
        data: result.items || [],
        pagination: {
          page: result.page,
          size: result.size,
          total: result.total,
          totalPages: result.totalPages,
          hasPrev: result.hasPrev,
          hasNext: result.hasNext,
        },
      });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba při načítání zákazníků',
      });
    }
  },
}));
